import { call, all } from 'redux-saga/effects';

import { onListCandidatesStart } from './list-candidates';

export default function* onCandidateAction() {
  yield all([call(onListCandidatesStart)]);
}
